<template>
  <div>
    <!-- 内容· -->
    <div class="width100 backwhite margin-bot20">
      <p
        class="
          f16
          width98
          textalign-left
          pad-bot20
          width96
          margin-auto
          dimensional
        "
      >
        认证申请
      </p>
      <!-- 内容表单 -->
      <div class="backwhite width98 margin-auto">
        <div class="bg-box">
          <p class="width100 textalign-left pad-bot10">资 产 名 称</p>
          <div class="box-right">
            <el-input
              class="inputDeep"
              placeholder="数字资产简要名称"
              v-model="researchtitle"
            />
          </div>
        </div>
        <div class="bg-box">
          <p class="width100 textalign-left pad-bot10">同 步 云 盘</p>
          <div class="box-right">
            <el-select
              v-model="title"
              placeholder="请选择项目类型"
              class="width100"
              :filterable="true"
            >
              <el-option label="---  请选择  ---" value=""></el-option>
              <el-option
                v-for="item in optionclass"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="bg-box">
          <p class="width100 textalign-left pad-bot10">权利人类型</p>
          <div class="box-right">
            <el-select
              v-model="project_number"
              class="width100 textalign-left"
              placeholder="请选择权利人类型"
              :filterable="true"
            >
              <el-option label="---  请选择  ---" value=""></el-option>
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="bg-box">
          <p class="width100 textalign-left pad-bot10">权利人名称</p>
          <div class="box-right">
            <el-input
              class="inputDeep"
              placeholder="请输入权利人名称"
              v-model="nature"
            />
          </div>
        </div>
        <div class="bg-box">
          <p class="width100 textalign-left pad-bot10">证 件 号 码</p>
          <div class="box-right">
            <el-input
              class="inputDeep"
              placeholder="权利人证件号码"
              v-model="fundnumber"
            />
          </div>
        </div>
        <div class="bg-box">
          <p class="width100 textalign-left pad-bot10">资 产 文 件</p>
          <div class="box-right">
            <el-input
              class="inputDeep"
              placeholder="  请上传费用凭证"
              v-model="fund"
              maxlength="0"
            >
              <template slot="append">
                <el-upload
                  class="upload-demo"
                  :action="Apisrc"
                  :before-upload="beforeUpload"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :on-progress="handleprogress"
                  :on-success="handlesuccess"
                  :on-error="handleerror"
                  :show-file-list="false"
                  :data="user"
                  :headers="head"
                  multiple
                  :limit="3"
                  :on-exceed="handleExceed"
                >
                  <el-button>上传</el-button
                  ><i
                    slot="prefix"
                    class="iconfont iconfontes icon-jiantou_liebiaoxiangyou"
                  ></i> </el-upload
              ></template>
            </el-input>
          </div>
        </div>
        <div class="bg-box">
          <p class="width100 textalign-left pad-bot10">项 目 备 注</p>
          <div class="box-right">
            <el-input
              type="textarea"
              :autosize="autosize"
              v-model="remark"
              placeholder="请输入项目备注"
              class="inputDeep"
              maxlength="500"
              rows="5"
              cols="20"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="textalign-right">
      <el-button @click="dialognull()">取 消</el-button>
      <el-button type="primary" @click="Savechanges()">保 存</el-button>
    </div>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { documentindex, documentdelete } from "@/api/loader/loder.api";
import { makersave } from "@/api/patent/patent.api";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      autosize: {
        minRows: 3,
        maxRows: 1000,
      },
      errormessage: "",
      dialogVisiblenull: false,
      str: "",
      title: "",
      project_number: "",
      start_date: "",
      nature: "",
      researchtitle: "",
      fund: "",
      fundnumber: "",
      source: "",
      progress: "",
      remark: "",
      id: "",
      projectName: "",

      companybox: [],
      options: [
        {
          value: 0,
          label: "个人",
        },
        {
          value: 1,
          label: "企业",
        },
      ],
      user: {
        cate_id: "",
        filename: "",
      },
      head: {
        token: window.sessionStorage.getItem("token"),
      },
      page: "",
      responseid: "",
      responseurl: "",
      Apisrc: "",
      optionclass: [],
      fileid: "",
    };
  },

  methods: {
    // 上传
    beforeUpload(file) {
      this.user.filename = file.name;
      this.user.cate_id = this.title;
    },
    handleprogress(file, fileList) {
      this.user.filename = fileList.name;
    },
    handleRemove(file, fileList) {},
    handlePreview(file) {},
    handlesuccess(response, file, fileList) {
      if (response.msg == "上传文件后缀不允许") {
        this.dialogVisiblenull = true;
        this.errormessage = response.msg;
      } else {
        this.responseid = response.data.id;
        this.responseurl = response.data.url;
        this.fund = file.name;
        this.$loadings.hide(); // 隐藏loading
        this.fileid = response.data.id;
      }
    },
    handleerror(err, file, fileList) {
      this.$loadings.hide(); // 隐藏loading
      this.dialogVisiblenull = true;
      this.errormessage = "上传失败,请选择同步的云盘文件夹";
    },

    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    Savechanges() {
      if (this.fund == "") {
        this.dialogVisiblenull = true;
        this.errormessage = "未上传文件";
      } else {
        makersave({
          title: this.researchtitle,
          file_id: this.responseid,
          cate_id: this.title,
          obligee: this.nature,
          obligee_type: this.project_number,
          cert_number: this.fundnumber,
          url: this.responseurl,
          remark: this.remark,
        }).then((res) => {
          if (res.data.code == 200) {
            this.$message({
              showClose: true,
              message: "保存成功",
              type: "success",
            });
            BUS.$emit("applicationcer", "yes");
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    dialognull() {
      BUS.$emit("applicationcer", "yess");
    },
  },

  created() {
    this.Apisrc = window.g.ApiUrl + "/maker/uploader";
    documentindex().then((res) => {
      if (res.data.code == 200) {
        this.page = res.data.data.dir;
        this.optionclass.push({ id: 0, name: "不同步网盘" });
        this.page.forEach((i) => {
          this.optionclass.push(i);
        });
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>

<style scoped>
/* 表单盒子 */
.bg-box {
  width: 100%;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  padding: 5px 0 5px 0;
  color: #353a44;
  margin: auto;
}
.box-right {
  width: 100%;
  font-size: 14px;
}
.button {
  width: 80px;
  line-height: 32px;
  font-size: 14px;
  color: white;
  background: #e2e2e2;
  border: none;
  border-radius: 5px;
  margin: 0 0 0 10px;
}
::placeholder {
  color: #a4a4a4;
}

.errorbox >>> .el-dialog__body {
  text-align: center;
}
</style>
